import {
    Chip,
    ChipProps,
    ThemeOptions,
    ThemeProvider,
    createTheme,
    useTheme,
} from '@mui/material';
import { deepmerge } from '@mui/utils';

const Tag = (props: ChipProps) => {
    const theme = useTheme();
    const tagTheme: ThemeOptions = {
        components: {
            MuiChip: {
                styleOverrides: {
                    root: {
                        borderRadius: 99,
                    },
                },
            },
        },
    };

    const mergedTheme = deepmerge(theme, tagTheme);
    return (
        <ThemeProvider theme={mergedTheme}>
            <Chip {...props} />
        </ThemeProvider>
    );
};

export default Tag;
